import FAR_FUTURE_TIME from './FarFutureTime';
import Debug from '../../util/Debug';
const InstantStore = () => {
    const map = new Map();
    const listeners = new Set();
    function removeListener(listener) {
        listeners.delete(listener);
    }
    function notifyListeners(instant) {
        Array.from(listeners).forEach((listener) => {
            try {
                const shouldContinueListening = listener.onInstantMarked(instant);
                if (!shouldContinueListening) {
                    removeListener(listener);
                }
            }
            catch (error) {
                Debug.warn(`Warning: Caught error in onInstantMarked: ${error}`);
            }
        });
    }
    return {
        addListener(listener) {
            listeners.add(listener);
        },
        removeListener,
        mark(instant, timestamp) {
            // TODO: Isolate by tenant
            map.set(instant, timestamp || Date.now());
            notifyListeners(instant);
        },
        timeOf(instant) {
            return map.get(instant) || FAR_FUTURE_TIME;
        },
    };
};
export default InstantStore();
//# sourceMappingURL=InstantStore.js.map